import { useCallback } from 'react';
import { can, type Action, type PermissionContext, type Resource } from '@shared/permissions';
import type { Role } from '@shared/types';

export function usePermission(role: Role | null | undefined) {
  return useCallback(
    (action: Action, resource: Resource, ctx?: PermissionContext) => can(role, action, resource, ctx),
    [role],
  );
}
